import Jobs from '../components/jobs/Jobs';
import JobsCreate from '../components/jobs/JobsCreate';
import JobsEdit from '../components/jobs/JobsEdit';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/jobs',
  component: Template,
  children: [
    {
      path: '',
      name: 'Jobs',
      component: Jobs,
      meta: {
        title: 'Jobs - Mod24',
      },
    },
    {
      path: 'create',
      name: 'JobsCreate',
      component: JobsCreate,
      meta: {
        title: 'Create Job - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'JobsEdit',
      component: JobsEdit,
      meta: {
        title: 'Edit Job - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/jobsRoutes.js